// GENERATED by scripts/icons/sync.mjs from packages/ui/icons/catalog.json.
// brand marks; edit the catalog, never this file.

import type { IconSvgElement } from '@hugeicons/react';
import {
  NewTwitterIcon as NewTwitterIconSolid,
  RedditIcon as RedditIconSolid,
  TelegramIcon as TelegramIconSolid,
  WhatsappIcon as WhatsappIconSolid,
} from '@hugeicons-pro/core-solid-standard';
import {
  AppleIcon,
  GoogleIcon,
  InstagramIcon,
  NewTwitterIcon,
  TelegramIcon,
  TiktokIcon,
  YoutubeIcon,
} from '@hugeicons-pro/core-stroke-standard';

export {
  AppleIcon,
  GoogleIcon,
  InstagramIcon,
  NewTwitterIcon,
  NewTwitterIconSolid,
  RedditIconSolid,
  TelegramIcon,
  TelegramIconSolid,
  TiktokIcon,
  WhatsappIconSolid,
  YoutubeIcon,
};

export const SOLID_BRAND_ICONS: ReadonlySet<IconSvgElement> = new Set([
  NewTwitterIconSolid,
  RedditIconSolid,
  TelegramIconSolid,
  WhatsappIconSolid,
]);
